/**
 * Directive that listens for all swChange insides & fires the provided
 * callback if any of them is changed.
 */
angular.module('coreModule').directive('swChangeWrapper', ($parse) => {
  return {
    restrict: 'A',
    link: function (scope: any, element, attrs) {
      scope.swChangeWrapper = $parse(attrs.swChangeWrapper);
    },
    controller: class {
      constructor(private $scope: any) {
        this.$scope = $scope;
      }

      change(value) {
        if (angular.isFunction(this.$scope.swChangeWrapper)) {
          this.$scope.swChangeWrapper(this.$scope, { value });
        }
      }
    },
  };
});
